<template>
  <div class="mini-promgram-regiseter">
    <h1>注册小程序</h1>
    <el-form ref="form" :model="register" label-width="100px">
      <el-form-item label="法人姓名" required>
        <el-input v-model="register.legal_persona_name" placeholder="请填写法人姓名"></el-input>
        <span class="input-hint">法人姓名需要跟绑定微信银行卡的姓名一致</span>
      </el-form-item>

      <el-form-item label="法人微信" required>
        <el-input v-model="register.legal_persona_wechat" placeholder="请填写法人微信号"></el-input>
        <span class="input-hint">需使用绑定法人银行卡的微信号</span>
      </el-form-item>

      <el-form-item label="企业名称" required>
        <el-input v-model="register.name" placeholder="请填写工商营业执照商的企业全称"></el-input>
        <span class="input-hint">企业名称需要与工商部门登记信息一致</span>
      </el-form-item>

      <el-form-item label="企业代码类型" required>
        <el-select v-model="register.code_type" placeholder="请选择企业代码类型">
          <el-option label="统一社会信用代码" value="1"></el-option>
          <el-option label="组织机构代码" value="2"></el-option>
          <el-option label="营业执照注册号" value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="企业代码" required>
        <el-input v-model="register.code" placeholder="请填企业代码"></el-input>
      </el-form-item>

      <el-alert
        :title="auditFailedReason"
        type="error"
        style="margin: 10px 0"
        v-if="register.state === 'failed'"
      />
      <div style="margin-left: 100px;">
        <el-form-item>
          <div v-if="register.state === 'pending'" class="danger" > 正在审核, 不能修改 </div>
          <div v-else-if="register.state === 'failed'">
            <el-button type="primary" @click="onSubmit">更新信息</el-button>
          </div>
          <div v-else>
            <el-button type="primary" @click="onSubmit">立即创建</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component
  export default class Register extends Vue {

    register = {
      name: '',
      code: '',
      code_type: '',
      legal_persona_wechat: '',
      legal_persona_name: '',
      audit_result: {},
    }

    get auditFailedReason() {
      return `微信审核失败：${_.get(this.register, 'audit_result.msg')}`
    }

    async mounted() {
      const register = await this.$request.get('/wechat_third_party_platform/registers/info');
      _.merge(this.register, register)
    }

   async onSubmit() {
    await this.$autoLoading(
      this.$request.post('/wechat_third_party_platform/registers', {
        ...this.register
      })
    );
    this.$message.success('提交成功，请注意微信下发的模板消息，及时完成认证！');
    this.$router.push({ name: 'home' });
    }
  }
</script>

<style lang="scss">
  .mini-promgram-regiseter {
    padding: 50px;
    width: 500px;
    h1 {
      margin-left: 200px;
    }
    .danger {
      color: red;
    }
    .input-hint {
      color: #9397a0;
      font-size: 12px;
    }
  }
</style>
